import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNpday75 } from './pages'

type TIdToPageMapWoofzNpday75 = Record<PageIdWoofzNpday75, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NPDAY_75: TIdToPageMapWoofzNpday75 = {
  [PageId.SUBSCRIPTIONS_NPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/subscriptions/SubscriptionNpday75'
      ).then((m) => ({
        default: m.SubscriptionsNpday75,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/subscriptions/SubscriptionNpday75'
      ),
  },
  [PageId.CHAT_UPSELL_NPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_npday/woofz_npday_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzNpday75.DOWNLOAD_NPDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNpday75.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
